export const rcpaPricingVersions = [
  ['rcpa-1.0-2025-01-16', { label: 'Version 1' }],
  ['rcpa-1.0.1-2027-01-01', { label: 'Version 1.0.1 - Terrorism tax €8.50' }],
] as const

export type RcpaPricingVersion = (typeof rcpaPricingVersions)[number][0]
